import React from "react"

import "../../../style/saas-setup-tab.module.css"

interface Props {
}

const ProdNoPublicAppTab = (_: Props) => {

  return (
    <div className="setup-tab">
      <p>
        You must create a production instance for the <b><code>public</code></b> app before you can create a production instance for this app. Use the dropdown above to switch to the <b><code>public</code></b> app.
      </p>
    </div>
  )
}

export default ProdNoPublicAppTab
